module.exports = __webpack_public_path__ + "img/machineThre-img1.0a1e6d80.jpg";